const Config = {
  title: 'Parhaat lainat aina edullisesti',
  url: 'https://www.myrsky.fi',
  logo: '',
}

export default Config
